module.exports = __webpack_public_path__ + "assets/1792649897182/img/coupon-content-bg.45a20d47.png";